module.exports = __webpack_public_path__ + "img/lvoa.8ac1daeb.png";